export const INPUT_MSG = {
  CHECK_NICKNAME_SUCCESS: '사용 가능한 닉네임입니다.',
  CHECK_PHONE_SUCCESS: '사용가능한 휴대폰 번호입니다.',
  PIN_CHECK_FAILED: 'PIN 비밀번호가 틀렸습니다. 다시 입력해주세요',
  INVALID_PASSWORD: '비밀번호가 잘못 입력되었습니다.',
  CHECK_PWD_FAILED: '비밀번호가 일치하지 않습니다.',
  CHECK_FEE_FAILED: '전송 수수료인 솔라나(SOL)가 부족합니다.\n 솔라나 잔액을 확인해주세요!',
};

export const BUTTON_MSG = {
  SEND_LOCKED: '출금에 실패했습니다.\n 관리자에게 문의해주세요.',
  SEND_CANCEL: '취소하시겠습니까?',
  SEND_COMPLETE: '전송이 요청되었습니다.\n\n 전송이 완료될 때까지\n 몇분이 소요될 수 있습니다',
  BALANCE_NOT_ENOUGH: '보유금을 초과할 수 없습니다.',
  INVALID_ADDRESS: '유효하지 않는 주소입니다.',
  CHECK_PWD_FAILED: '비밀번호가 일치하지 않습니다.',
  SET_PWD_SUCCESS: '비밀번호가 변경되었습니다.',
  SET_PWD_FAILED: '비밀번호 변경에 실패하였습니다.',
  WITHDRAW_CONFIRM: '탈퇴 후에는\n전자지갑 자산을 복구할 수 없습니다.\n 정말로 탈퇴하시겠습니까?',
  WITHDRAW_SUCCESS: '회원탈퇴가 완료되었습니다.',
  PIN_SET_SUCCESS: 'PIN 비밀번호가 재설정되었습니다.',
  CLIPBOARD_NOT_SUPPORTED: '이 브라우저에서는\n 자동 붙여넣기가 지원되지 않습니다.\n 직접 텍스트를 입력해주세요.',
};
